// extracted by mini-css-extract-plugin
export default {"wrapper":"nE-z","button":"oE-z","alternate":"pE-z","disabled":"qE-z","paymentWarning":"rE-z","fadeIn":"sE-z"};